<!-- =========================================================================================
  File Name: Incidents.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <request-incident-sidebar :isSidebarActive="addIncidentaSidebar" @closeSidebar="toggleDataSidebar"  :data="sidebarData" />
    <add-incident-sidebar :isSidebarActive="editIncidentaSidebar" @closeSidebar="edittoggleDataSidebar"  :data="editsidebarData" />
    <upload-video-sidebar :isSidebarActive="uploadVideoSidebar" @closeSidebar="uploadVideotoggleDataSidebar"  :data="uploadVideoSidbarData" />


    <!-- ADD NEW -->
      <vs-popup fullscreen title="" :active.sync="popupActive">
    <div id="page-camera-view" >
    <iframe  width="100%" height="490" class="center" :src="reset"  allowfullscreen></iframe>
  </div>
      </vs-popup>
    <vs-button class="user_add_btn" type="filled" @click="addNewData"><feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3" /> Request Incident</vs-button>
    <vs-table ref="table"  pagination :max-items="itemsPerPage" search  :data="filteredIncidentList">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown v-if="selected.length>0" vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
           <vx-tooltip text="Search By Location" position="top" v-if="locln>1">
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2" v-html="custom_search_filter">{{ $t('student.filters.search_by_location') }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="setSelected('Search By Location')">
                <span class="flex items-center">
                  <span  >ALL</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item v-for="location in locations" :key="location.id" @click="setSelected(location.name)">
                <span class="flex items-center">
                  <span >{{ location.name }}</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
          </vx-tooltip>

        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ incidents.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : incidents.length }} of {{ queriedincidents }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <!-- <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item> -->
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>
        <span  @click="sorting('name')">NAME</span>
        <feather-icon v-if="nameorder && namestate" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sorting('name')" />
        <feather-icon v-if="!nameorder && namestate" icon="ChevronUpIcon" svgClasses="h-4 w-4"  class="ml-1" @click="sorting('name')" />
        </vs-th>
        <vs-th >Location</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>
        <span  @click="sortingdate('date')">CREATED</span>
        <feather-icon v-if="dateorder && datestate" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingdate('date')" />
        <feather-icon v-if="!dateorder && datestate" icon="ChevronUpIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingdate('date')" />
        </vs-th>
        <vs-th v-if="role!='manager'">Action</vs-th>
      </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].name"> <router-link :to="{ path: '/incident/'+ tr.id}" class="text-inherit">{{tr.name}}</router-link></vs-td>
               <vs-td>{{tr.location.name }}</vs-td>
              <vs-td v-if="tr.status"><vs-chip>{{tr.status}}</vs-chip></vs-td>
              <vs-td v-else><vs-chip>Requested</vs-chip></vs-td>
              <vs-td>{{tr.created_at | formatDate}}</vs-td>
              <vs-td   class="whitespace-no-wrap">
                 <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer " >
                  <div >
                    <feather-icon svgClasses="w-6 h-6 hover:text-primary stroke-current"  icon="MoreVerticalIcon"></feather-icon>
                  </div>
                  <vs-dropdown-menu>
                  <!-- <vs-dropdown-item v-if="role!='manager'">
                <span class="flex items-center" @click="uploadVideo(tr)">
                  <feather-icon icon="UploadIcon" svgClasses="h-4 w-4" />
                  <span> Upload Videos </span>
                </span>
                  </vs-dropdown-item> -->
                    <vs-dropdown-item >
                <span class="flex items-center" @click="editNewData(tr)">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" />
                  <span> {{ $t('common.edit') }} </span>
                </span>
                  </vs-dropdown-item>
                  <vs-dropdown-item>
                <span class="flex items-center" @click="confirmDeleteRecord(tr)">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4"/>
                  <span>{{ $t('common.delete') }}</span>
                </span>
                </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>
<script>
import RequestIncidentSidebar from './RequestIncidentSidebar.vue'
import AddIncidentSidebar from './AddIncidentSidebar.vue'
import UploadVideoSidebar from './UploadVideoSidebar.vue'
import {
  ALL_INCIDENTS,
  ALL_LOCATIONS,
  MANAGER_INCIDENTS,
  MANAGER_LOCATION,
  ME_DATA,
  PLAY_CAMERA,
  REMOVE_INCIDENT
} from "@/graphql";
import moment from 'moment'

export default {

  components: {
      moment,
      RequestIncidentSidebar,
      AddIncidentSidebar,
      UploadVideoSidebar

  },
  data () {
    return {
      incidents:[],
      selected: [],
      itemsPerPage: 10,
      isMounted: false,
      popupActive: false,
      IframeSrc:'',
      addIncidentaSidebar: false,
      sidebarData: {},
      editIncidentaSidebar: false,
      uploadVideoSidebar: false,
      editsidebarData: {},
      uploadVideoSidbarData: {},
      role:'',
      locations:'',
      custom_search_filter:'Search By Location',
      DeletedItem:'',
      nameorder:false,
      dateorder:true,
      namestate:false,
      datestate:false,

    }
  },
filters: {
  formatTime: function (value) {
    if (value) {
    return moment(String(value),'h:mm A').format('h:mm A')
  }
  },
  formatDate: function (value) {
    if (value) {
    return moment(String(value)).format('MM/DD/YYYY h:mm A')
  }
  },
},
  computed: {
    filteredIncidentList: function () {
      var parameter = this.$route.params.status
      var custom_search_filter = this.custom_search_filter
      var order= this.order
      return this.incidents.filter(function(incident) {
        if(parameter!='requested'){
        if (custom_search_filter == 'Search By Location') {
         return true;
        }
        if(custom_search_filter !== 'Search By Location'){
        return incident.location.name.match(custom_search_filter);
        }
        return true;
        }
       if(parameter=='requested'){

          if(incident.status=='Requested'){
                return true
        }
        return false
       }
      });

    },
    reset(){
       if(this.popupActive){
         return this.IframeSrc
       }
       if(!this.popupActive){
         return
       }
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    products () {
      return this.$store.state.dataList.products
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    },
    queriedincidents () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.incidents.length
    },
    locln() {
      return this.locations.length
    },

  },
  methods: {
    sorting(name){
    this.namestate=true
    this.datestate=false
    var column=name
    this.dateorder=true
    var order=this.nameorder
    if(column=='name' && order==true){
    this.nameorder=!this.nameorder
    this.incidents.sort(function(a, b) {
    var textA = a.name.toUpperCase();
    var textB = b.name.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
});
}
 if(column=='name' && order==false){
    this.nameorder=!this.nameorder
    this.incidents.sort(function(a, b) {
    var textA = a.name.toUpperCase();
    var textB = b.name.toUpperCase();
    return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
});
}
  } ,
sortingdate(name){
   this.datestate=true
   this.namestate=false
   var column=name
   this.nameorder=true
   var dateorder=this.dateorder
  if(column=='date' && dateorder==true){
    this.dateorder=!this.dateorder
    this.incidents.sort(function(a, b) {
    var textA = a.created_at
    var textB = b.created_at
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
});
}
 if(column=='date' && dateorder==false){
    this.dateorder=!this.dateorder
    this.incidents.sort(function(a, b) {
    var textA = a.created_at
    var textB = b.created_at
    return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
});

}
  } ,
//   sorting(name){
//     var column=name
//     var order=this.order
//     if(this.order=="asc")
//     {
//       this.order="dec"
//     }
//     else{
//       this.order="asc"
//     }
//     if(column=='name' && order=='asc'){
//     this.incidents.sort(function(a, b) {
//     var textA = a.name.toUpperCase();
//     var textB = b.name.toUpperCase();
//     return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
// });
// }
//  if(column=='name' && order=='dec'){
//     this.incidents.sort(function(a, b) {
//     var textA = a.name.toUpperCase();
//     var textB = b.name.toUpperCase();
//     return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
// });
// }
//   if(column=='date' && order=='asc'){
//     this.incidents.sort(function(a, b) {
//     var textA = a.created_at
//     var textB = b.created_at
//     return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
// });
// }
//  if(column=='date' && order=='dec'){
//     this.incidents.sort(function(a, b) {
//     var textA = a.created_at
//     var textB = b.created_at
//     return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
// });
// }
//   } ,
    //  handleSort(key, active) {
    //   console.log(`the user ordered: ${key} ${active}`)
    // },
    setSelected(value) {
      this.custom_search_filter = value;
    },
      StatusSuccess() {
      this.$vs.notify({
        title: "Incident",
        text:   'Incident Successfully Deleted',
        color:  'success',
        position: 'top-right'
      })
      },
    confirmDeleteRecord(incident) {
      this.DeletedItem = incident.id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${incident.name}"`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
    deleteData(incident) {
      this.$apollo
        .mutate({
          mutation: REMOVE_INCIDENT,
          variables: {
            id: this.DeletedItem,
          },
        })
        .then(response => {
          if (response.data.deleteIncident.status == 'SUCCESS') {
            this.StatusSuccess()
            this.get()
          }
            }).catch(error => {
            console.log(error)
          });

     },
     editNewData (data) {
      this.editsidebarData = data
      this.edittoggleDataSidebar(true)
    },
    uploadVideo (data) {
      this.uploadVideoSidbarData = data
      this.uploadVideotoggleDataSidebar(true)
    },
     edittoggleDataSidebar (val = false) {
      this.editIncidentaSidebar = val
         this.get()
      },
    uploadVideotoggleDataSidebar (val = false) {
      this.uploadVideoSidebar = val
      if(!val){
         this.get()
      }
      },
     addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
     toggleDataSidebar (val = false) {
      this.addIncidentaSidebar = val
      if(!val){
         this.get()
      }
    },
     PalyCamera(id){
       this.$apollo
           .mutate({
            mutation: PLAY_CAMERA,
            variables: {
            id:id,
           }
          })
            .then(response => {
              if (response) {
              // this.IframeSrc=response.data.playCamera.embed_code
               this.IframeSrc='https://www.dropbox.com/s/5ui1g3zpdbokt51/Focused%20Observations%20Chapter%204%20Video%209_360p%20%281%29.mp4?raw=1'
              this.popupActive=true
                          }
            }).catch(error => {
            console.log(error)
          });

      //  let embed_codes = [
      //    '',
      //    'https://www.youtube.com/embed/I7n7yX5fmRc',
      //    'https://www.youtube.com/embed/fdZJiWnxhg0',
      //    'https://www.youtube.com/embed/WcoKuFw_q_k'
      //  ];

      //  if( typeof( embed_codes[id] ) != 'undefined' )
      //  {
      //    this.IframeSrc= embed_codes[id];
      //  }
      //  else
      //  {
      //    this.IframeSrc = 'https://www.youtube.com/embed/I7n7yX5fmRc';
      //  }

      //   this.popupActive=true

    },
    get(){
      if(this.role=='admin'){
       this.$apollo
      .mutate({
        mutation: ALL_INCIDENTS,
      })
      .then(response => {
        this.incidents = response.data.Incidents
        this.nameorder = !this.nameorder
        this.sorting('name')
      })
         this.$apollo
      .mutate({
        mutation: ALL_LOCATIONS,
      })
      .then(response => {
        this.locations=response.data.locations
      })
      }
      else{
        this.$apollo
      .mutate({
        mutation: MANAGER_INCIDENTS,
      })
      .then(response => {
        this.incidents = response.data.ManagerIncidents.incidents
        this.nameorder = !this.nameorder
        this.sorting('name')
      }).catch(error => {
          console.log(error)
      });
       this.$apollo
      .mutate({
        mutation: ME_DATA,
      })
      .then(response => {
        this.conditionMethod(response.data.me.roles[0].name,response.data.me.id)
      }).catch(error => {
          console.log(error)
      });
      }
    },
    conditionMethod(role,id){
     if(role=="manager"){
      this.$apollo
      .mutate({
        mutation: MANAGER_LOCATION,
        variables: {
        id:id
     },
      })
        .then(response => {
          this.locations=response.data.user.managerlocations
      }).catch(error => {
          console.log(error)
      });
      }
  },

  },
  created () {
    const userRoles = JSON.parse(localStorage.getItem('user-roles'))
    this.role=userRoles[0]['name']
    this.get()

  },
  mounted () {
    this.isMounted = true
  }
}
</script>
<style lang="scss">
#data-list-list-view {
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.center {
  border: 1px solid #c3c3c3;
  display: flex;
  align-content: center;
  justify-content: center;
  padding: 0px;
  margin:0px;
}
</style>
